import gql from 'graphql-tag'
export default gql`
mutation deleteSite($domain: String!){
    deleteSite(domain: $domain)
  }
  `